import dynamic from "next/dynamic";

const ClientLottiePlayer = dynamic(() => import("react-lottie-player"), {
  ssr: false,
});

export default ClientLottiePlayer;
